var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 6.58498L12.593 1.99298C12.7808 1.80534 13.0354 1.69998 13.3008 1.70007C13.5663 1.70017 13.8209 1.80571 14.0085 1.99348C14.1961 2.18126 14.3015 2.43588 14.3014 2.70134C14.3013 2.96679 14.1958 3.22134 14.008 3.40898L9.41699 7.99998L14.008 12.591C14.1958 12.7786 14.3013 13.0332 14.3014 13.2986C14.3015 13.5641 14.1961 13.8187 14.0085 14.0065C13.9156 14.0995 13.8053 14.1732 13.6839 14.2236C13.5624 14.2739 13.4323 14.2998 13.3008 14.2999C13.0354 14.3 12.7808 14.1946 12.593 14.007L7.99999 9.41498L3.40799 14.007C3.31502 14.1 3.20464 14.1737 3.08316 14.224C2.96168 14.2743 2.83148 14.3002 2.69999 14.3002C2.43444 14.3002 2.17977 14.1948 1.99199 14.007C1.80422 13.8192 1.69873 13.5645 1.69873 13.299C1.69873 13.0334 1.80422 12.7788 1.99199 12.591L6.58399 7.99998L1.99399 3.40898C1.80622 3.22134 1.70068 2.96679 1.70058 2.70134C1.70049 2.43588 1.80585 2.18126 1.99349 1.99348C2.18113 1.80571 2.43568 1.70017 2.70114 1.70007C2.9666 1.69998 3.22122 1.80534 3.40899 1.99298L7.99999 6.58498Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.518dfab3.svg";
export { ForwardRef as ReactComponent };